<template>
  <v-row justify="center" class="ma-0">
    <v-col cols="12" class="pa-0">
      <v-toolbar color="primary" height="60" dark class="elevation-0">
        <v-toolbar-title>連絡先</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
    </v-col>
    <v-col cols="12" class="pa-0">
      <v-card>
        <v-card-text class="pa-1 overflow-y-auto" :style="dialogHeight">
          <v-container>
            <v-row>
              <v-col cols="6" class="py-0">
                <v-select
                  ref="type"
                  :items="$CONTACT_TYPES"
                  label="*種別"
                  v-model="item.type"
                  dense
                  :rules="[rules.required]"
                  item-text="name"
                  item-value="key"
                  @change="onChangeType()"
                ></v-select>
              </v-col>
              <v-col v-if="item.type == 2 || item.type == 3" cols="6" class="py-0">
                <v-select
                  :items="$GENDERS"
                  label="性別"
                  v-model="item.gender"
                  dense
                  :disabled="item.type == 1"
                  item-value="key"
                  item-text="name"
                ></v-select>
              </v-col>
              <v-col v-else cols="6" class="pb-0">
              </v-col>
              <template v-if="item.type == 2 || item.type == 3">
                <v-col cols="6" class="py-0">
                  <v-text-field
                    label="姓（漢字）"
                    v-model="item.sei"
                    :disabled="item.type == 1"
                  ></v-text-field>
                </v-col>
                <v-col cols="6" class="py-0">
                    <v-text-field
                      label="名（漢字）"
                      v-model="item.mei"
                      :disabled="item.type == 1"
                    ></v-text-field>
                  </v-col>
                <v-col cols="6" class="py-0">
                    <v-text-field
                      label="姓（ふりがな）"
                      v-model="item.seiY"
                      :disabled="item.type == 1"
                    ></v-text-field>
                </v-col>
                  <v-col cols="6" class="py-0">
                    <v-text-field
                      label="名（ふりがな）"
                      v-model="item.meiY"
                      :disabled="item.type == 1"
                    ></v-text-field>
                </v-col>
              </template>
              <template v-if="item.type == 1">
                <v-col cols="6" class="py-0">
                  <v-text-field
                    ref="zip"
                    v-model="item.zip"
                    label="*郵便番号"
                    append-outer-icon="search"
                    type="text"
                    @click:append-outer="onSearch()"
                    @keyup.enter.native="onSearch()"
                    :disabled="item.type != 1"
                    hideDetails
                  ></v-text-field>
                </v-col>
                <v-col cols="12" class="py-0">
                  <v-text-field
                    ref="address"
                    v-model="item.address"
                    label="住所"
                    hideDetails
                    :disabled="item.type != 1"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" class="py-0">
                  <v-text-field class="caption"
                    ref="address2"
                    v-model="item.address2"
                    label="住所（番地・建屋名称・部屋番号）"
                    :disabled="item.type != 1"
                  ></v-text-field>
                </v-col>
              </template>
              <template>
                <v-col cols="12" class="py-0">
                  <v-text-field
                    ref="email2"
                    prepend-icon="mdi-cellphone"
                    v-model="item.email2"
                    :rules="[rules.email]"
                    label="メール（携帯電話）"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" class="py-0">
                  <v-text-field
                    ref="email"
                    prepend-icon="mdi-laptop"
                    v-model="item.email"
                    :rules="[rules.email]"
                    label="メール（パソコン）"
                  ></v-text-field>
                </v-col>
                <v-row align="center" class="px-3">
                  <v-col cols="5" class="py-0">
                    <v-text-field
                      ref="mobile"
                      v-model="item.mobile"
                      label="携帯電話"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="3" class="pa-0">
                    <template-time-picker
                      :id="3"
                      :icon="'mdi-clock-outline'"
                      :time="item.available2.from"
                      @updated="onUpdated"
                    ></template-time-picker>
                  </v-col>
                  <v-col cols="3" class="pa-0">
                    <template-time-picker
                      :id="4"
                      :icon="'mdi-minus'"
                      :time="item.available2.to"
                      @updated="onUpdated"
                    ></template-time-picker>
                  </v-col>
                  <v-col cols="1" class="pa-0">
                    <v-btn icon small class="ma-0 pa-0" @click="item.available2.flag = !item.available2.flag">
                      <v-icon :color="item.available2.flag ? 'primary' : 'error'">{{ item.available2.flag ? 'mdi-circle-double' : 'mdi-close-circle-outline' }}</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
                <v-row align="center" class="px-3">
                  <v-col cols="5" class="py-0">
                    <v-text-field
                      ref="fixed"
                      v-model="item.phone"
                      label="固定電話"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="3" class="pa-0">
                    <template-time-picker
                      :id="1"
                      :icon="'mdi-clock-outline'"
                      :time="item.available1.from"
                      @updated="onUpdated"
                    ></template-time-picker>
                  </v-col>
                  <v-col cols="3" class="pa-0">
                    <template-time-picker
                      :id="2"
                      :icon="'mdi-minus'"
                      :time="item.available1.to"
                      @updated="onUpdated"
                    ></template-time-picker>
                  </v-col>
                  <v-col cols="1" class="pa-0">
                    <v-btn icon small class="ma-0 pa-0" @click="item.available1.flag = !item.available1.flag">
                      <v-icon :color="item.available1.flag ? 'primary' : 'error'">{{ item.available1.flag ? 'mdi-circle-double' : 'mdi-close-circle-outline' }}</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
                <v-col cols="12" class="py-0">
                  <v-textarea
                    prepend-inner-icon="mdi-pencil-box"
                    name="input-7-4"
                    v-model="item.memo"
                    label="メモ"
                    outlined
                    hide-details>
                  </v-textarea>
                </v-col>
              </template>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn rounded depressed @click.native="close()">取消</v-btn>
          <v-btn color="primary" rounded depressed @click.native="submit()">{{ item.id ? '更新' : '登録' }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-col>

    <div>
      <app-loading :loading="loading"></app-loading>
    </div>

  </v-row>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
import TimePicker from '../common/TemplateTime.vue'
Vue.component('template-time-picker', TimePicker)
export default {
  data () {
    return {
      loading: false,
      formHasErrors: false,
      rules: {
        required: value => !!value || '必須',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || '無効なメールアドレスです'
        }
      }
    }
  },
  props: [ 'user', 'item', 'dialog', 'type' ],
  computed: {
    ...mapGetters({
      windowSize: 'shared/windowSize'
    }),
    form () {
      return {
        type: this.item.type
      }
    },
    dialogHeight () {
      var h = Math.round(this.windowSize.y * 0.6)
      h = h > 700 ? 700 : h
      return 'max-height: ' + String(h) + 'px;'
    }
  },
  created () {
    Vue.prototype.$CONTACT_TYPES = [
      { key: 1, name: '生徒本人' },
      { key: 2, name: '保護者' },
      { key: 3, name: 'その他' }
    ]
    if (typeof this.item.available1 === 'undefined') {
      this.item['available1'] = { from: null, to: null, flag: true }
    }
    if (typeof this.item.available2 === 'undefined') {
      this.item['available2'] = { from: null, to: null, flag: true }
    }
    if (typeof this.item.memo === 'undefined') {
      this.item['memo'] = null
    }
  },
  methods: {
    onChangeType () {
      if (this.item.type === 2) {
        this.item.sei = JSON.parse(JSON.stringify(this.user.sei))
        this.item.seiY = JSON.parse(JSON.stringify(this.user.seiY))
        this.item.mei = null
        this.item.meiY = null
      } else {
        this.item.sei = null
        this.item.seiY = null
        this.item.mei = null
        this.item.meiY = null
      }
    },
    checkName (v) {
      if (this.item.type === '生徒本人') {
        return true
      } else {
        return v !== null
      }
    },
    close () {
      this.$emit('dismissed', { item: null })
    },
    submit () {
      this.formHasErrors = false
      Object.keys(this.form).forEach(f => {
        if (!this.form[f]) {
          if (f === 'name') {
            if (this.item.type !== '生徒本人') {
              this.formHasErrors = true
            }
          } else {
            this.formHasErrors = true
          }
        }
        this.$refs[f].validate(true)
      })
      if (!this.formHasErrors) {
        this.$emit('dismissed', { item: this.item })
      }
    },
    onUpdated: function (value) {
      switch (value.id) {
        case 1:
          this.item.available1.from = value.time
          break
        case 2:
          this.item.available1.to = value.time
          break
        case 3:
          this.item.available2.from = value.time
          break
        case 4:
          this.item.available2.to = value.time
          break
      }
    },
    onSearch () {
      var vm = this
      if (this.item.zip === '' || this.item.zip.length < 7) {
        return
      }
      this.loading = true
      var payload = this.item.zip
      this.$store.dispatch('postcode/search', payload).then(function (data) {
        if (data) {
          vm.item.address = data.val().a7
        } else {
          vm.item.address = null
          vm.item.address2 = null
        }
        vm.loading = false
      })
    }
  }
}
</script>
